









































import {Vue, Component, Prop, VModel} from 'vue-property-decorator';
import {v4 as uuidv4} from "uuid";

export type Icon = "xmark" | "arrow-left"

@Component({})
export default class RightSideBar extends Vue {
	@Prop({default: function () {return uuidv4()}})
	private id!: string;

	@Prop()
	private title!: string

	@Prop({default: "xmark"})
	private closeIcon!: Icon

	@VModel({type: Boolean, default: false})
	private model!: boolean
}
